export const SAVE_HISTORY = 'SAVE_HISTORY';
export const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';
